import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-switch-button',
  templateUrl: './toggle-switch-button.component.html',
  styleUrls: ['./toggle-switch-button.component.scss'],
  standalone: false,
})
export class ToggleSwitchButtonComponent implements OnInit {
  toggleSwitch = false; // Default false is the off state or the corresponding off or on Label
  id: string; // Need to add an unique id for the switch checkbox for accessibility
  @Input() offStateLabel: string; // Toggle off (false) or when toggle is clicked to the left
  @Input() onStateLabel: string; // Toggle on (true) or when toggle is clicked to the right
  @Input() toggleElearningSwitch: boolean;
  @Output() toggleState = new EventEmitter<boolean>();

  constructor() {}

  /**
   * OnInit - Generate a unique id for the switch checkbox
   */
  ngOnInit(): void {
    if (this.toggleElearningSwitch) {
      this.onToggleChange();
    }
    this.generateUniqueId();
  }

  /**
   * Generate a unique id consisting of the strings of off and on state labels that has been slugified.
   * All strings are lowercased and the empty space is replaced with a hypen
   */
  generateUniqueId(): void {
    if (this.offStateLabel && this.onStateLabel) {
      // Set a unique id for the toggle switch and add it to the label in template
      this.id =
        this.offStateLabel.toLowerCase().replace(' ', '-') +
        '-' +
        this.onStateLabel.toLowerCase().replace(' ', '-');
    }
  }

  /**
   * Emit toggle switch state on change
   * Default is false (off state or when switch is to the left),
   * true is (on state or when switch is to the right)
   */
  onToggleChange(): void {
    this.toggleSwitch = !this.toggleSwitch;
    this.toggleElearningSwitch = !this.toggleSwitch;

    // Emit the boolean toggle state and let the component that is listening to this emitter
    // handle the corresponding action.
    this.toggleState.emit(this.toggleSwitch);
  }
}
